// Canonical provider_key → display-name map for Transaction-backed online
// payments. Mirrors api/utils/providerDisplay.js CANONICAL_PROVIDER_NAMES
// exactly — keep in sync. Rows lacking a resolvable provider identity use
// the operator-decided legacy label.
const CANONICAL_PROVIDER_NAMES = Object.freeze({
  'provider.paystack': 'Paystack',
  'provider.flutterwave': 'Flutterwave',
  'provider.interswitch': 'Interswitch',
  'provider.squad': 'Squad',
});

const LEGACY_PROVIDER_LABEL = 'Legacy/Paystack';

function canonicalProviderName(providerKey) {
  if (providerKey == null || providerKey === '') return null;
  return CANONICAL_PROVIDER_NAMES[String(providerKey)] || null;
}

// provider_name → providerName → canonical(provider_key/providerKey)
// → 'Legacy/Paystack' (operator product decision: legacy online rows were
// Paystack).
function paymentProviderLabel(payment) {
  if (!payment) return LEGACY_PROVIDER_LABEL;
  return (
    payment.provider_name ||
    payment.providerName ||
    canonicalProviderName(payment.provider_key || payment.providerKey) ||
    LEGACY_PROVIDER_LABEL
  );
}

export { CANONICAL_PROVIDER_NAMES, LEGACY_PROVIDER_LABEL, canonicalProviderName, paymentProviderLabel };
